import KeywordNotesTypeSubTypeCount from './keywordNotesTypeSubTypeCount'
export default KeywordNotesTypeSubTypeCount
